import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { INTERVENTIONS_INCLUDES } from "@/entities/interventions";
import InterventionAddButton from "@/modules/intervention/intervention-add-button";
import { ListProvider } from "@/modules/list";

const { Content } = Layout;

const Interventions = () => {
  const { t } = useTranslation();

  const InterventionIncludes = [
    INTERVENTIONS_INCLUDES.USERS,
    INTERVENTIONS_INCLUDES.TEMPLATE,
  ];

  return (
    <>
      <BaseHeader title={t("navigation:interventions")} />
      <Content>
        <ListProvider
          endpoint="interventions"
          storageKey={STORAGE_KEYS.INTERVENTIONS}
          includes={InterventionIncludes}
        >
          <InterventionsTable
            showLocationColumn
            showAssetColumn
            extraActions={<InterventionAddButton />}
          />
        </ListProvider>
      </Content>
    </>
  );
};

export default Interventions;
